import { Component, signal, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { Pair } from "../obj/Pair";
import { AbstractBuyerComponent } from "./abstract/buyer.component";
import { AuthService } from "../service/auth.service";
import { AnalyticsService } from "../service/analytics.service";
import { GeneralService } from "../service/general.service";
import { ValidationService } from "../service/validation.service";
import { State } from "../entity/State";
import { AlertType } from "../entity/AlertType";
import { AlertTypeOption } from "../entity/AlertTypeOption";
import { AlertSubscription } from "../entity/AlertSubscription";
import { HeaderComponent } from "./incs/header.component";
import { MatTabGroup, MatTab, MatTabLabel } from "@angular/material/tabs";
import { NgxMaskDirective } from "ngx-mask";
import { firstValueFrom } from "rxjs";

@Component({
    selector: "kilowant-register",
    templateUrl: "../../html/main-user-details.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [HeaderComponent, MatTabGroup, MatTab, MatTabLabel, FormsModule, NgxMaskDirective, ReactiveFormsModule]
})
export class UserDetailsComponent extends AbstractBuyerComponent {
    alertsData: Pair[] = [];
    selectedAlerts: AlertSubscription[] = [];

    currentPhoneNumber: FormControl = new FormControl("");

    old_password: string = "";
    password: string = "";
    password2: string = "";
    oldPasswordType: string = "password";
    password2Type: string = "password";
    passwordType: string = "password";
    isSupplier: boolean = false;
    inEditMode: number = 0;
    viewAlertsCategory: boolean[] = [];

    fileToUpload: File | null = null;
    deleteTaxExemptCertificateDocument: boolean;

    allowEditEmail = signal<boolean>(false);

    constructor(router: Router,
        route: ActivatedRoute,
        authService: AuthService,
        dialog: MatDialog,
        analyticsService: AnalyticsService,
        generalService: GeneralService,
        public validationService: ValidationService) {
        super(router, route, dialog, authService, analyticsService, generalService);
    }

    ngOnInit(): void {
        super.ngOnInit();
    }

    pageStart(): void {
        this.generalService.getAlerts().then((alertsData: any) => {
            this.alertsData = alertsData;
            for (var i = 0; i < this.alertsData.length; i++) {
                this.viewAlertsCategory.push(false);
            }
        });
        this.generalService.getSelectedAlerts().then((selectedAlerts: any) => {
            this.selectedAlerts = selectedAlerts;
        });
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }

    sendForm(): void {
        this.clearErrors();
        if (this.user.firstName == null || this.user.firstName.length == 0) {
            this.addError("firstName");
        }
        if (this.user.lastName == null || this.user.lastName.length == 0) {
            this.addError("lastName");
        }
        if (this.currentPhoneNumber.value == null || this.currentPhoneNumber.value.length == 0) {
            this.addError("Phone");
        }
        if (this.user.addressLine1 == null || this.user.addressLine1 == "") {
            this.addError("addressLine1");
        }
        if (this.user.company != null && (this.user.company.name == null || this.user.company.name == "")) {
            this.addError("company");
        }

        if (this.user.zip == null || this.user.zip.length == 0) {
            this.addError("zip");
        }

        if (this.errorY().showError()) {
            this.setErrorText("Please enter the data requested above.");
            return;
        }

        if (this.user.city == null || this.user.city.length == 0 || this.user.state == null) {
            this.addError("zip");
            this.setErrorText("Zip code is not correct.");
            return;
        }

        if (this.user.jobTitle.length > 0 && !this.validationService.validate("User", "jobTitle", this.user.jobTitle, this.errorY, "JobTitle")) {
            return;
        }
        if (!this.validationService.validate("User", "firstName", this.user.firstName, this.errorY)) {
            return;
        }
        if (!this.validationService.validate("User", "lastName", this.user.lastName, this.errorY)) {
            return;
        }
        if (!this.validationService.validate("User", "addressLine1", this.user.addressLine1, this.errorY)) {
            return;
        }
        if (!this.validationService.validate("User", "zip", this.user.zip, this.errorY)) {
            return;
        }
        if (this.user.company != null && !this.validationService.validate("Company", "name", this.user.company.name, this.errorY)) {
            return;
        }

        if (!this.currentPhoneNumber.valid) {
            this.addError("Phone");
            this.setErrorText("Phone number is not correct.");
            return;
        }
        this.user.phone = this.currentPhoneNumber.value;

        this.generalService.checkUpdateUserEmail(this.user.email).subscribe(
            {
                next: (response: any) => {
                    this.updateUserProceed();
                },
                error: (err: any) => {
                    if (err.status == 400) {
                        this.addError("email");
                        this.setErrorText(err.error);
                    }
                }
            }
        );
    }

    updateUserProceed(): void {
        this.generalService.updateUser(this.user, 0, this.fileToUpload, this.deleteTaxExemptCertificateDocument, false).subscribe(
            {
                next: (res: any) => {
                    if (res) {
                        this.inEditMode = 0;
                        this.generalService.clearFromSessionByPrefix("user_details");
                        this.reloadUser().then(u => this.refreshView());
                    }
                },
                error: (err) => {
                    if (err.status == 400) {
                        this.setErrorText(err.error);
                    }
                }
            }
        );
    }

    sendUpdatePasswordForm(): void {
        this.clearErrors();
        if (this.old_password == null || this.old_password.length == 0) {
            this.addError("OldPassword");
        }
        if (this.password == null || this.password.length == 0) {
            this.addError("Password");
        }
        if (this.password2 == null || this.password2.length == 0) {
            this.addError("Password2");
        }
        if (this.errorY().showError()) {
            this.setErrorText("Please enter the data requested above in order to update your password.");
            return;
        }

        if (!this.validationService.validate("User", "password", this.password, this.errorY, "Password")) {
            return;
        }
        if (this.password != this.password2) {
            this.addError("Password2");
            this.setErrorText("Passwords do not match.");
            return;
        }

        this.generalService.updateUserPassword(this.old_password, this.password).subscribe(
            {
                next: (res: any) => {
                    if (res) {
                        this.inEditMode = 0;
                        this.refreshView();
                    }
                },
                error: (err: any) => {
                    if (err.status == 400) {
                        this.setErrorText(err.error);
                    }
                }
            }
        );
    }

    editMode(newMode: number): void {
        this.inEditMode = newMode;
        this.clearErrors();
        this.reloadUser();
        this.currentPhoneNumber.setValue(this.user.phone);
        this.allowEditEmail.set(false);
        this.refreshView();
    }

    clearPassword(): void {
        this.old_password = "";
        this.password = "";
        this.password2 = "";
    }

    addRemoveAlert(alertType: AlertType, alertOption: AlertTypeOption): void {
        if (alertOption == null) {
            var pos = this.positionInSelected(alertType, null);
            if (pos >= 0) {
                this.selectedAlerts.splice(pos, 1);
            } else {
                var subscription = new AlertSubscription();
                subscription.alertType = alertType;
                this.selectedAlerts.push(subscription);
            }
        } else if (alertType.multiOption) {
            var pos = this.positionInSelected(alertType, alertOption);
            if (pos >= 0) {
                this.selectedAlerts.splice(pos, 1);
            } else {
                var subscription = new AlertSubscription();
                subscription.alertType = alertType;
                subscription.alertOption = alertOption;
                this.selectedAlerts.push(subscription);
            }
        } else {
            var pos = this.positionInSelected(alertType, alertOption);
            if (pos >= 0) {
                this.selectedAlerts.splice(pos, 1);
            } else {
                let poss = this.positionsInSelected(alertType);
                for (let i = poss.length - 1; i >= 0; i--) {
                    this.selectedAlerts.splice(poss[i], 1);
                }
                var subscription = new AlertSubscription();
                subscription.alertType = alertType;
                subscription.alertOption = alertOption;
                this.selectedAlerts.push(subscription);
            }
        }
    }

    addRemoveAlertsMultiple(alertType: AlertType, alertOptions: AlertTypeOption[]): void {
        if (alertOptions == null || alertOptions.length == 0) {
            var pos = this.positionInSelected(alertType, null);
            if (pos >= 0) {
                this.selectedAlerts.splice(pos, 1);
            } else {
                var subscription = new AlertSubscription();
                subscription.alertType = alertType;
                this.selectedAlerts.push(subscription);
            }
        } else if (alertType.multiOption) {
            let poss = this.positionsInSelected(alertType);
            for (let i = 0; i < alertOptions.length; i++) {
                var pos = this.positionInSelected(alertType, alertOptions[i]);
                if (pos >= 0 && poss.length > 0) {
                    this.selectedAlerts.splice(pos, 1);
                } else if (poss.length == 0) {
                    var subscription = new AlertSubscription();
                    subscription.alertType = alertType;
                    subscription.alertOption = alertOptions[i];
                    this.selectedAlerts.push(subscription);
                }
            }
        } else {
            let poss = this.positionsInSelected(alertType);
            if (poss.length > 0) {
                for (let i = poss.length - 1; i >= 0; i--) {
                    this.selectedAlerts.splice(poss[i], 1);
                }
            } else {
                var subscription = new AlertSubscription();
                subscription.alertType = alertType;
                subscription.alertOption = alertOptions[0];
                this.selectedAlerts.push(subscription);
            }
        }
    }

    positionsInSelected(alertType: AlertType): number[] {
        var res: number[] = [];
        for (var i = 0; i < this.selectedAlerts.length; i++) {
            if (this.selectedAlerts[i] != null && this.selectedAlerts[i].alertType != null && this.selectedAlerts[i]!.alertType!.id == alertType.id) {
                res.push(i);
            }
        }
        return res;
    }

    positionInSelected(alertType: AlertType, alertOption: AlertTypeOption | null): number {
        for (var i = 0; i < this.selectedAlerts.length; i++) {
            if (this.selectedAlerts[i] != null && this.selectedAlerts[i].alertType != null && this.selectedAlerts[i]!.alertType!.id == alertType.id &&
                (this.selectedAlerts[i].alertOption == null || (alertOption != null && this.selectedAlerts[i].alertOption!.id == alertOption.id))
            ) {
                return i;
            }
        }
        return -1;
    }

    getStateName(state: State | null): string {
        if (state == null) {
            return "";
        }
        return state.stateCode;
    }

    zipChanged(): void {
        this.resetError('zip');
        this.user.city = "";
        this.user.state = null;
        if (this.user.zip!=null && this.user.zip?.length > 2) {
            let request = this.generalService.getStateCityByZip(this.user.zip);
            if (request == null) {
                return;
            }
            firstValueFrom(request).then(data => {
                if (data != null) {
                    this.user.state = data.key;
                    this.user.city = data.value;
                    this.refreshView();
                }
            });
        }
    }

    setAlerts(): void {
        this.generalService.setSelectedAlerts(this.selectedAlerts).subscribe(
            {
                next: (res: any) => {
                    if (res) {
                        this.inEditMode = 0;
                    }
                },
                error: (err) => {
                    if (err.status == 400) {
                        this.setErrorText(err.error);
                    }
                }
            }
        );
    }

    clearAlerts() {
        this.selectedAlerts = [];
    }

    downloadFile(ifExisting: boolean, id: number | null) {
        if (!ifExisting) {
            this.generalService.sendFileToClient(this.fileToUpload);
        } else if (id != null) {
            this.generalService.openDocument(id);
        }
    }

    deleteFile() {
        this.fileToUpload = null;
    }

    handleFileInput(event: Event) {
        const target = event.target as HTMLInputElement;
        this.fileToUpload = (target.files as FileList).item(0) as File;
        this.resetError("fileToUpload");
    }

    deleteExistingFile() {
        this.deleteTaxExemptCertificateDocument = true;
        if (this.user.company != null) {
            this.user.company.taxExemptCertificateDocument = null!;
        }
    }

    showPassword(type: string) {
        if (type == "oldPasswordType") {
            if (this.oldPasswordType === "password") {
                this.oldPasswordType = "text";
            } else {
                this.oldPasswordType = "password";
            }
        } else if (type == "passwordType") {
            if (this.passwordType === "password") {
                this.passwordType = "text";
            } else {
                this.passwordType = "password";
            }
        } else if (type == "password2Type") {
            if (this.password2Type === "password") {
                this.password2Type = "text";
            } else {
                this.password2Type = "password";
            }
        }
    }
}
